import ModalConfigurationSetting from './ModalConfigurationSetting'

export default ModalConfigurationSetting
